import "./ccTrust.css";

/* The AI callout. Three points, in the order an office actually asks them:
   what is the AI working from, who sets the limits, and is it even built for
   this. Nothing here is claimed beyond what the page commits to elsewhere —
   SSO and data handling sit in the IT block above, not in this one.

   The first point used to say RAIN never completes the work, which the job
   seeker page contradicts on the same day it was written: students are
   offered drafted bullets, letters and outreach, and that is the point of
   the product. The claim a director actually needs is narrower and true on
   both pages — RAIN builds from what the student did, and the student edits
   before anything goes out. Keep the two pages saying the same thing. */
const commitments = [
  {
    title: "It builds from what students actually did",
    body: "Nothing invented, nothing pasted in blind. Resume bullets come from questions about what the student did. Cover letters and outreach start as drafts built from their own answers, which they edit before anything goes out.",
  },
  {
    title: "Guardrails you set",
    body: "You set the boundaries. Students reach your office with a stronger draft and sharper questions.",
  },
  {
    title: "Career-specific, not a general chatbot",
    body: "Grounded in recruiting norms and the way your office advises, not in whatever the internet says.",
  },
];

const CcTrust = () => (
  <section className="cc-trust-section" id="trust">
    <div className="home-container">
      <div className="cc-trust">
        <div className="cc-trust-copy">
          <h2 className="cc-trust-title">
            AI that teaches thinking, not shortcuts
          </h2>
          <p className="cc-trust-sub">
            Students are already using AI for career prep. RAIN gives your
            office a way to guide it.
          </p>
          <a className="cc-trust-btn" href="#book">
            Book a walkthrough
          </a>
        </div>

        <div className="cc-trust-points">
          <ul className="cc-trust-list">
            {commitments.map(({ title, body }) => (
              <li key={title}>
                <h3 className="cc-trust-item-title">{title}</h3>
                <p className="cc-trust-item-body">{body}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </section>
);

export default CcTrust;
